// CONFIGURATION: Images and Link
const DESKTOP_IMAGE_URL = "https://cdn.shopify.com/s/files/1/0589/3934/2980/files/data_privacy_day_desktop.png?v=1768839276";
const MOBILE_IMAGE_URL = "https://cdn.shopify.com/s/files/1/0589/3934/2980/files/data_privacy_day_mobile.png?v=1768839275";
const LINK_URL = "https://keepyourhomeip.com/collections/shop";

// CONFIGURATION: Schedule (ISO 8601 Format)
// Format: YYYY-MM-DDTHH:mm:ss-Offset
const SALE_START = "2026-01-20T06:00:00+01:00"; // 6:00 AM CET Jan 20, 2026 (Amsterdam)
const SALE_END   = "2026-02-01T06:00:00+01:00"; // 6:00 AM CET Feb 1, 2026 (Amsterdam)

(function() {
    // 0. Date Check Logic
    function isSaleActive() {
        const now = new Date();
        const start = new Date(SALE_START);
        const end = new Date(SALE_END);
        
        // If current time is before start OR after end, return false
        if (now < start || now > end) {
            return false;
        }
        return true;
    }

    // 1. Define the CSS styles for the modal
    const styles = `
        .bf-modal-overlay {
            position: fixed; top: 0; left: 0; width: 100%; height: 100%;
            background: rgba(0, 0, 0, 0.8);
            z-index: 99999;
            display: none;
            align-items: center;
            justify-content: center;
            backdrop-filter: blur(2px);
            opacity: 0;
            transition: opacity 0.3s ease;
        }
        .bf-modal-container {
            position: relative;
            max-width: 90%; /* Default max-width for smaller screens */
            width: auto;
            transform: scale(0.9);
            transition: transform 0.3s ease;
        }
        /* NEW: Smaller max-width for desktop views (>= 769px) */
        @media (min-width: 769px) {
            .bf-modal-container {
                max-width: 600px; /* Reduced to 600px for a less intrusive desktop experience */
            }
        }
        .bf-close-btn {
            position: absolute;
            top: -15px;
            right: -15px;
            background: white;
            color: black;
            border: none;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            font-weight: bold;
            cursor: pointer;
            box-shadow: 0 2px 10px rgba(0,0,0,0.3);
            z-index: 100;
            display: flex; align-items: center; justify-content: center;
        }
        .bf-image { display: block; width: 100%; height: auto; border-radius: 8px; }
        
        /* Mobile vs Desktop Display Logic */
        .bf-desktop-img { display: block; }
        .bf-mobile-img { display: none; }
        
        @media (max-width: 768px) {
            .bf-desktop-img { display: none; }
            .bf-mobile-img { display: block; }
        }
        
        /* Animation States */
        .bf-visible { opacity: 1; }
        .bf-visible .bf-modal-container { transform: scale(1); }
    `;

    // 2. Define the HTML structure
    const html = `
        <div class="bf-modal-overlay" id="bfModalOverlay">
            <div class="bf-modal-container">
                <button class="bf-close-btn" id="bfCloseBtn">✕</button>
                <a href="${LINK_URL}">
                    <img src="${DESKTOP_IMAGE_URL}" class="bf-image bf-desktop-img" alt="Sale">
                    <img src="${MOBILE_IMAGE_URL}" class="bf-image bf-mobile-img" alt="Sale">
                </a>
            </div>
        </div>
    `;

    // 3. Inject Styles and HTML into the page
    function initModal() {
        // Check if we are within the sale period
        if (!isSaleActive()) {
            // Uncomment the line below if you want to debug why it's not showing
            // console.log("Black Friday Modal: Not currently within the sale period.");
            return;
        }

        // Inject CSS
        const styleSheet = document.createElement("style");
        styleSheet.innerText = styles;
        document.head.appendChild(styleSheet);

        // Inject HTML
        const div = document.createElement("div");
        div.innerHTML = html;
        document.body.appendChild(div);

        // Logic
        const overlay = document.getElementById("bfModalOverlay");
        const closeBtn = document.getElementById("bfCloseBtn");

        function open() {
            overlay.style.display = "flex";
            // Small timeout to allow display:flex to apply before adding opacity class for transition
            setTimeout(() => {
                overlay.classList.add("bf-visible");
            }, 10);
        }

        function close() {
            overlay.classList.remove("bf-visible");
            setTimeout(() => {
                overlay.style.display = "none";
            }, 300);
        }

        closeBtn.addEventListener("click", close);
        
        // Close on background click
        overlay.addEventListener("click", (e) => {
            if (e.target === overlay) close();
        });

        // Trigger after 1.5 seconds
        setTimeout(open, 1500);
    }

    // Run when DOM is ready
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initModal);
    } else {
        initModal();
    }

})();